import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

import Home from '@/pages/Home';
import About from '@/pages/About';
import OurProduct from '@/pages/OurProduct';
import ProductDetail from '@/pages/ProductDetail';
import ContactUs from '@/pages/ContactUs';
import RaiseServiceRequest from '@/pages/RaiseServiceRequest';
import TrackRequest from '@/pages/TrackRequest';
import SecureSDWAN from '@/pages/SecureSDWAN';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsAndConditions from '@/pages/TermsAndConditions';
import CustomerFeedback from '@/pages/CustomerFeedback';
import Career from '@/pages/Career';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />

        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/our-product" element={<OurProduct />} />

          {/* Existing Product Details */}
          <Route path="/products/:productId" element={<ProductDetail />} />

          {/* Other Pages */}
          <Route path="/contact-us" element={<ContactUs />} />
          <Route
            path="/raise-service-request"
            element={<RaiseServiceRequest />}
          />
          <Route path="/track-request" element={<TrackRequest />} />
          <Route path="/customer-feedback" element={<CustomerFeedback />}
/>
          <Route path="/secure-sd-wan" element={<SecureSDWAN />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/career" element={<Career />} />
        </Routes>
        

        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;